import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FailedComponent } from './failed/failed.component';
import { LoginComponent } from './login/login.component';
import { MsalGuard } from '@azure/msal-angular';
import { ProfileComponent } from './profile/profile.component';
import { TbAgentComponent } from './core/tb-agent/tb-agent.component';
import { QuestionsAgentComponent } from './core/questions-agent/questions-agent.component';
import { AgentFiveComponent } from './core/agent-five/agent-five.component';
import { IxbrlComponent } from './ixbrl/ixbrl.component';
// import { DocumentAcceptanceComponent } from './ixbrl/document-acceptance/document-acceptance.component';
import { DocumentFormattingComponent } from './ixbrl/document-formatting/document-formatting.component';
// import { DocumentReviewComponent } from './ixbrl/document-review/document-review.component';

export const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard],
    data: { title: 'Home | Corporate Income Tax Agent' },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login | Corporate Income Tax Agent' },
  },
  {
    path: 'login-failed',
    component: FailedComponent,
    data: { title: 'Login Failed | Corporate Income Tax Agent' },
  },
  {
    path: 'tb-agent',
    component: TbAgentComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Trial Balance Extraction Agent | Corporate Income Tax Agent',
    },
  },
  {
    path: 'questions-agent',
    component: QuestionsAgentComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Tax Questions Generation Agent | Corporate Income Tax Agent',
    },
  },
  {
    path: 'agent-five',
    component: AgentFiveComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Corporate Income Tax Review Agent | Corporate Income Tax Agent',
    },
  },
  {
    path: 'ixbrl',
    component: IxbrlComponent,
    canActivate: [MsalGuard],
    data: { title: 'Home | iXBRL Agent' },
  },
  // {
  //   path: 'document-acceptance',
  //   component: DocumentAcceptanceComponent,
  //   canActivate: [MsalGuard],
  //   data: { title: 'Document Acceptance | iXBRL Agent' },
  // },
  {
    path: 'document-formatting',
    component: DocumentFormattingComponent,
    canActivate: [MsalGuard],
    data: { title: 'Document Formatting | iXBRL Agent' },
  },
  // {
  //   path: 'document-review',
  //   component: DocumentReviewComponent,
  //   canActivate: [MsalGuard],
  //   data: { title: 'Document Review | iXBRL Agent' },
  // },
  {
    path: '',
    component: HomeComponent,
    canActivate: [MsalGuard],
    data: { title: 'Home | Corporate Income Tax Agent' },
  },
];
